import { Flex } from '@chakra-ui/react';
import { FormFieldCheckboxArray } from '@publishing-engine/domain/types/article';
import React, { useState } from 'react';
import CheckBoxArrayUpdateModal from './ChcekBoxArrayUpdateModal';
import { FieldHeader } from '../common/FieldHeader';
import { CheckBoxArrayEmptyState } from './CheckBoxArrayEmptyState';
import { CheckBoxArrayDisplay } from './CheckBoxArrayDisplay';
import { CheckBoxArrayDiffModal } from './CheckBoxArrayDiffModal';
import { EntryPoint } from 'src/utils/types';
import { useSubmissionFields } from 'src/hooks/useSubmissionFields';

export type CheckBoxField = FormFieldCheckboxArray;

type IProps = {
  formFieldDefinition: CheckBoxField;
  value: string[];
  previousValue?: string[] | null;
  onChange?: (value: string[]) => void;
  entryPoint: EntryPoint;
  isUpdateRequired?: boolean;
};

export const GenericCheckBoxArrayField: React.FC<IProps> = ({
  formFieldDefinition,
  value,
  previousValue,
  onChange,
  entryPoint,
  isUpdateRequired
}) => {
  const { checkFormFieldValueIsUpdated } = useSubmissionFields(entryPoint);

  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [showDiffModal, setShowDiffModal] = useState<boolean>(false);
  const openDiffModal = () => setShowDiffModal(true);
  const closeDiffModal = () => setShowDiffModal(false);
  const isEditable = !!onChange;

  const editCallback = isEditable
    ? () => {
        setIsEditing(true);
      }
    : undefined;

  const isUpdated = checkFormFieldValueIsUpdated(formFieldDefinition.name);

  return (
    <Flex flexDirection={'column'} gap={2}>
      {isEditing && onChange && (
        <CheckBoxArrayUpdateModal
          formField={formFieldDefinition}
          isOpen={isEditing}
          onCancel={() => {
            setIsEditing(false);
          }}
          value={value}
          onSubmit={(value: string[]) => {
            setIsEditing(false);
            onChange(value);
          }}
        />
      )}

      {isUpdated && showDiffModal ? (
        <CheckBoxArrayDiffModal
          fieldName={formFieldDefinition.params.labels.main}
          value={value}
          previousValue={previousValue}
          onClose={closeDiffModal}
          options={formFieldDefinition.params.labels.options}
        />
      ) : null}

      <FieldHeader
        {...formFieldDefinition}
        label={formFieldDefinition.params.labels.main}
        isUpdated={isUpdated}
        editCallback={editCallback}
        onShowDiffModal={openDiffModal}
        entryPoint={entryPoint}
        isUpdateRequired={isUpdateRequired}
      />

      {value ? (
        <CheckBoxArrayDisplay
          value={value}
          subtitle={''}
          options={formFieldDefinition.params.labels.options}
        />
      ) : (
        <CheckBoxArrayEmptyState />
      )}
    </Flex>
  );
};
